// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

export interface RequestRmaConfirmationEstimatedReturnAmountProps {
    estimatedReturnAmount: string;
    extendedStyles?: RequestRmaConfirmationEstimatedReturnAmountStyles;
}

export interface RequestRmaConfirmationEstimatedReturnAmountStyles {
    wrapper?: InjectableCss;
    estimatedReturnAmountText?: TypographyPresentationProps;
}

export const requestRmaConfirmationEstimatedReturnAmountStyles: RequestRmaConfirmationEstimatedReturnAmountStyles = {};

const RequestRmaConfirmationEstimatedReturnAmount: FC<RequestRmaConfirmationEstimatedReturnAmountProps> = ({
    estimatedReturnAmount,
    extendedStyles,
}) => {
    const [styles] = React.useState(() =>
        mergeToNew(requestRmaConfirmationEstimatedReturnAmountStyles, extendedStyles),
    );

    const { isRequestRmaSuccessPage } = useAppSelector(state => {
        return {
            isRequestRmaSuccessPage: getCurrentPage(state).type === "RequestRmaSuccessPage",
        };
    });
    if (!isRequestRmaSuccessPage || !estimatedReturnAmount) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="rmaConfirmation_estimatedReturnAmount">
            <Typography {...styles.estimatedReturnAmountText} as="h3">
                {translate("Estimated Return Amount")} {estimatedReturnAmount}
            </Typography>
        </StyledWrapper>
    );
};

export default RequestRmaConfirmationEstimatedReturnAmount;
